import React from 'react';
import PropTypes from 'prop-types';
import "./SearchBox.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { standardizeString } from 'utils/function';

const propTypes={
  defaultKeyword: PropTypes.string,
  onSearch: PropTypes.func,
};
const defaultProps={
  defaultKeyword: '',
  onSearch: (originalKeyword, analyzedKeywords) => {},
};
const SearchBox = (props) => {
  /*** States and Variables ***/
  const [keyword, setKeyword] = React.useState('');
  const [preKeyword, setPreKeyword] = React.useState('');
  /*** Processing ***/
  React.useEffect(()=>{
    if (keyword!==props.defaultKeyword) {
      setKeyword(props.defaultKeyword);
      setPreKeyword(props.defaultKeyword);
    }
  }, [props.defaultKeyword])
  /*** Sub Components ***/
  /*** Event Handlers ***/
  const onSubmit = (e) => {
    e.preventDefault();
    if(keyword!==preKeyword) {
      onSearch();
    }
  }
  const onSearch = () => {
    setPreKeyword(keyword);
    let keywords = standardizeString(keyword).replaceAll(/[、､ 　]/g,",");
		keywords = keywords.split(",");
		keywords = keywords.map(keyword=>keyword.trim());
		keywords = keywords.filter(keyword=>keyword!=="");
    props.onSearch(keyword, keywords);
  }
  /*** Main Render ***/
  return <form className='search_box_container' onSubmit={onSubmit}>
    <input
    className='search_box_input'
    autoCapitalize='off'
    value={keyword}
    onChange={(e)=>{setKeyword(e.target.value)}}
    />
    <button
    type='submit'
    className='search_box_button'
    disabled={keyword===preKeyword}>
      <FontAwesomeIcon icon={faMagnifyingGlass} />
    </button>
  </form>;
}
SearchBox.propTypes = propTypes;
SearchBox.defaultProps = defaultProps;
export default SearchBox;